
import { useMemo } from 'react';
import { Grid } from '@mui/material';
import { LayoutCrearDoc } from '../../layouts';
import { CardDetalles } from '../../components';





export const MisOpciones = () => {



    const CARDS_CONFIG = [
        {
            key: '1', title: "Tus Pedidos",
            description: "Mira y rastrea tus pedidos o compra algo de nuevo.",
            icon: 'pedidos', route: '/super/mis-pedidos',
            funcion: null, color:'#9C27B0',
        },
        {
            key: '2', title: "Tus Pagos",
            description: "Ver todas las transacciones y métodos de pagos.",
            icon: 'abono', route: '',
            funcion: null, color: '#9C27B0',
        },
        {
            key: '3', title: "Perfil",
            description: "Administrar, agregar o eliminar datos para una mejor experiencia.",
            icon: 'micuenta', route: '/super/perfil',
            funcion: null, color: '#4CAF50'
        },
        {
            key: '4', title: "Tus Mensajes",
            description: "Ver mensajes de la empresa para un mejor servicio.",
            icon: 'mensaje', route: '',
            funcion: null, color: '#FF9800'
        },
        {
            key: '5', title: "Pedidos Archivados",
            description: "Ver y administrar tus pedidos archivados.",
            icon: 'archivado', route: '',
            funcion: null, color: '#9C27B0'
        },
        {
            key: '6', title: "Carnet de Usuario",
            description: "Esta tarjeta es útil para identificar usuarios, permitiendo descargarla.",
            icon: 'carnet', route: '/super/micarnet',
            funcion: null, color: '#00897B'
        },
        {
            key: '7', title: "Seguridad de Cuenta",
            description: "Cambia tu contraseña periódicamente para mejor seguridad.",
            icon: 'seguridad', route: '/super/cambio-clave',
            funcion: null, color: '#F44336'
        },
    ];


    const cards = useMemo(() => CARDS_CONFIG, []);




    return (

        <LayoutCrearDoc titulo='Mi Cuenta' add={false}>
            <Grid container spacing={3} display="flex" justifyContent="flex-start" mt={4}>
            {cards.map((item) => (
                <CardDetalles item={item} key={item.key} />
            ))}
            </Grid>
        </LayoutCrearDoc>

    )
}
